<template>
  <div
    class="tw-block full-width app-settings tw-h-full tw-overflow-y-auto tw-px-8 tw-py-4 tw-font-inter tw-bg-gradient-to-br tw-from-[#EDF3F9] tw-via-[#F3F7FA] tw-to-[#DAE6F0]"
  >
    <div class="col-auto tw-pb-4">
      <Error
        :error="state.error"
        @on-close="clearError"
      />

      <q-card
        flat
        class="panel tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-border tw-border-solid tw-border-line tw-shadow-[0_16px_48px_-16px_rgba(23,105,182,0.25)]"
      >
        <div class="tw-h-1 tw-bg-gradient-to-r tw-from-primary tw-via-[#4A9BD8] tw-to-secondary" />

        <q-card-section class="pad-panel column">
          <div class="col row items-center no-wrap tw-gap-2 tw-mb-1.5">
            <div class="tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-lg tw-bg-primary/10">
              <q-icon
                name="mdi-domain"
                size="16px"
                class="tw-text-primary"
              />
            </div>
            <span class="provision">Provisionamento VonixPhone</span>
          </div>

          <div class="col row items-center no-wrap tw-gap-2 q-mt-md tw-mb-1.5">
            <div class="tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-lg tw-bg-secondary/15">
              <q-icon
                name="mdi-headset"
                size="16px"
                class="tw-text-secondary-hover"
              />
            </div>
            <span class="provision">Headset</span>
          </div>

          <label
            for="inputPhone"
            class="col"
          >
            <span class="label">Microfone</span>
            <FieldSelect
              data-testid="configuracoes-microfone"
              :list="inputPhone.list"
              v-model="inputPhone.value"
              label="inputPhone"
            />
            <span
              v-if="deviceHint('inputPhone')"
              data-testid="configuracoes-microfone-aviso"
              class="device-hint"
            >
              <q-icon name="mdi-alert-circle-outline" />
              {{ deviceHint('inputPhone') }}
            </span>
          </label>

          <label
            for="outputPhone"
            class="col mt8"
          >
            <span class="label">Saída de áudio</span>
            <FieldSelect
              data-testid="configuracoes-saida-audio"
              :list="outputPhone.list"
              v-model="outputPhone.value"
              label="outputPhone"
            />
            <span
              v-if="deviceHint('outputPhone')"
              data-testid="configuracoes-saida-audio-aviso"
              class="device-hint"
            >
              <q-icon name="mdi-alert-circle-outline" />
              {{ deviceHint('outputPhone') }}
            </span>
          </label>

          <label
            for="additionalDevice"
            class="col mt8"
          >
            <span class="label">Campainha</span>
            <FieldSelect
              data-testid="configuracoes-campainha"
              :list="outputPhone.list"
              v-model="additionalDevice.value"
              label="additionalDevice"
            />
            <span
              v-if="deviceHint('additionalDevice')"
              data-testid="configuracoes-campainha-aviso"
              class="device-hint"
            >
              <q-icon name="mdi-alert-circle-outline" />
              {{ deviceHint('additionalDevice') }}
            </span>
          </label>

          <div class="col row items-center no-wrap tw-gap-2 q-mt-md tw-mb-1.5">
            <div class="tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-lg tw-bg-positive/10">
              <q-icon
                name="mdi-tune-variant"
                size="16px"
                class="tw-text-[#16A34A]"
              />
            </div>
            <span class="provision">Preferências</span>
          </div>

          <label
            for="locationSummaryAgent"
            class="col"
          >
            <span class="label">Sumário do agente</span>
            <FieldSelect
              data-testid="configuracoes-sumario-agente"
              :list="locationSummaryAgent.list"
              v-model="locationSummaryAgent.value"
              label="locationSummaryAgent"
            />
          </label>

          <label
            for="useDND"
            class="col mt8"
            v-if="isVisible('useDND')"
          >
            <span class="label">Usar DND</span>
            <FieldSelect
              data-testid="configuracoes-dnd"
              :list="useDND.list"
              v-model="useDND.value"
              label="useDND"
            />
          </label>

          <label
            class="col mt8"
            v-if="isVisible('dndOptionsList')"
          >
            <div class="column">
              <span
                v-if="useDND.value === 'yes' && !dndOptionsList.length"
                class="text-red self-center q-mb-xs"
              >(Por favor, marque no mínimo um canal para bloqueio)
              </span>
              <span class="label">Bloquear canais durante DND*</span>
            </div>

            <q-option-group
              data-testid="configuracoes-dnd-canais"
              v-model="dndOptionsList"
              type="checkbox"
              :options="[
                { label: 'Chamadas', value: 'VOICE' },
                { label: 'Chats', value: 'TEXT' },
                { label: 'E-mails', value: 'MAIL' }
              ]"
              color="primary"
              dense
              inline
              class="mt8"
            />
          </label>

          <label
            v-if="isVisible('dndCallTypes')"
            class="col mt8"
          >
            <span class="label">Tipo de chamadas:</span>
            <FieldSelect
              data-testid="configuracoes-dnd-tipo-chamadas"
              :list="dndCallTypes.list"
              v-model="dndCallTypes.value"
              label="dndCallTypes"
            />
          </label>

          <label
            for="groupQuickAnswers"
            class="col mt8"
          >
            <span class="label">Agrupar respostas rápidas por categoria</span>
            <FieldSelect
              data-testid="configuracoes-agrupar-respostas-rapidas"
              :list="groupQuickAnswers.list"
              v-model="groupQuickAnswers.value"
              label="groupQuickAnswers"
            />
          </label>

          <label
            for="groupMinPerfilator"
            class="col mt8"
          >
            <span class="label">Minimizar Perfilador</span>
            <FieldSelect
              data-testid="configuracoes-minimizar-perfilador"
              :list="groupMinPerfilator.list"
              v-model="groupMinPerfilator.value"
              label="groupMinPerfilator"
            />
          </label>

          <label
            for="windowToForeground"
            class="col mt8"
          >
            <span class="label">Mostrar VonixPhone ao receber atendimento automático</span>
            <FieldSelect
              data-testid="configuracoes-trazer-janela"
              :list="windowToForeground.list"
              v-model="windowToForeground.value"
              label="windowToForeground"
            />
          </label>

          <label
            for="notificationStyle"
            class="col mt8"
          >
            <span class="label">Notificação da agenda</span>
            <FieldSelect
              data-testid="configuracoes-notificacao-agenda"
              :list="notificationStyle.list"
              v-model="notificationStyle.value"
              label="notificationStyle"
            />
          </label>

          <label
            for="notificationStyle"
            class="col mt8"
          >
            <span class="label">Cochicho para atendimento automático</span>
            <FieldSelect
              data-testid="configuracoes-cochicho"
              :list="autoPlayback.list"
              v-model="autoPlayback.value"
              label="autoPlayback"
            />
          </label>

          <q-item
            v-if="autoPlayback.value === 'yes'"
            class="q-px-none q-py-none"
          >
            <q-item-section
              avatar
              class="q-pr-sm"
            >
              <q-icon
                name="mdi-volume-high"
                size="sm"
                color="grey-7"
              />
            </q-item-section>

            <q-item-section>
              <q-slider
                data-testid="configuracoes-volume-cochicho"
                v-model="autoAlertVolume.value"
                :min="0"
                label
                track-color="primary"
                inner-track-color="grey-6"
                :inner-min="autoAlertVolume.min"
                :max="autoAlertVolume.max"
                :step="autoAlertVolume.step"
                color="primary"
              />
            </q-item-section>
          </q-item>

          <div
            v-if="autoPlayback.value === 'yes'"
            class="row justify-end q-pr-sm"
          >
            <q-btn
              data-testid="configuracoes-testar"
              flat
              dense
              no-caps
              label="Testar"
              color="primary"
              class="q-px-sm tw-rounded-md tw-transition hover:tw-bg-muted"
              icon="mdi-bell-ring-outline"
              @click="testAutoAlert"
            />
          </div>

          <label
            for="installer"
            class="col mt8 text-right"
            v-if="binaryVersion"
          >
            <span class="label">Instalador: <b>{{ binaryVersion }}</b></span>
          </label>

          <div class="col q-mt-xl">
            <div class="row items-center">
              <div class="col">
                <q-btn
                  data-testid="configuracoes-cancelar"
                  flat
                  dense
                  no-caps
                  label="Cancelar"
                  color="primary"
                  class="tw-rounded-md tw-transition hover:tw-bg-muted"
                  v-if="!showWelcomeMessage && sipConnected"
                  @click="onCancel"
                />
              </div>

              <div
                class="col text-center appVersion"
              >
                VP: {{ version }}
              </div>

              <div class="col text-right">
                <q-btn
                  data-testid="configuracoes-salvar"
                  :loading="loading"
                  :disable="disableSave"
                  dense
                  no-caps
                  unelevated
                  label="Salvar"
                  class="q-px-md tw-rounded-md tw-font-medium tw-shadow-sm tw-transition-all tw-duration-200 hover:tw-bg-primary-hover hover:tw-shadow-md active:tw-scale-95"
                  color="primary"
                  @click="onSaveSettings"
                />
              </div>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Error from '@/components/Error'
import FieldSelect from '@/components/FieldSelect'
import { getVersion } from '@/libs/version'
import { AUDIO_DEVICE_FIELDS, listAudioDevices, onAudioDevicesChange } from '@/libs/audioDevices'

import { SETTINGS_NAMES, settingValue, visibleFieldNames } from '@/libs/settingsFields'

export default {
  components: {
    Error,
    FieldSelect
  },

  data () {
    const version = getVersion()
    const state = this.$store.state.settingsModule
    const showWelcomeMessage = !state?.customer

    return {
      version,
      showWelcomeMessage,

      loading: false,
      devicesLoaded: false,
      micDenied: false,

      inputPhone: {
        value: null,
        list: []
      },

      outputPhone: {
        value: null,
        list: []
      },

      additionalDevice: {
        value: settingValue(state, 'additionalDevice')
      },

      locationSummaryAgent: {
        value: settingValue(state, 'locationSummaryAgent'),
        list: [{
          id: 'topo',
          label: 'Topo'
        }, {
          id: 'rodape',
          label: 'Rodapé'
        }]
      },

      useDND: {
        value: settingValue(state, 'useDND'),
        list: [{
          id: 'no',
          label: 'Não'
        }, {
          id: 'yes',
          label: 'Sim'
        }]
      },

      dndOptionsList: settingValue(state, 'dndOptionsList'),
      dndCallTypes: {
        value: settingValue(state, 'dndCallTypes'),
        list: [{
          id: 'IN',
          label: 'Receptivas'
        }, {
          id: 'AUTO',
          label: 'Automáticas'
        }, {
          id: 'ALL',
          label: 'Receptivas e automáticas'
        }]
      },

      groupQuickAnswers: {
        value: settingValue(state, 'groupQuickAnswers'),

        list: [{
          id: 'no',
          label: 'Não'
        }, {
          id: 'yes',
          label: 'Sim'
        }]
      },

      groupMinPerfilator: {
        value: settingValue(state, 'groupMinPerfilator'),

        list: [{
          id: 'no',
          label: 'Não'
        }, {
          id: 'yes',
          label: 'Sim'
        }]
      },

      windowToForeground: {
        value: settingValue(state, 'windowToForeground'),

        list: [{
          id: 'no',
          label: 'Não'
        }, {
          id: 'yes',
          label: 'Sim'
        }]
      },

      notificationStyle: {
        value: settingValue(state, 'notificationStyle'),

        list: [
          {
            id: 'popup',
            label: 'Pop-up'
          }, {
            id: 'sound',
            label: 'Som'
          },
          {
            id: 'soundAndPopup',
            label: 'Som e Pop-up'
          }
        ]
      },

      autoPlayback: {
        value: settingValue(state, 'autoPlayback'),

        list: [{
          id: 'no',
          label: 'Não'
        }, {
          id: 'yes',
          label: 'Sim'
        }]
      },

      autoAlertVolume: {
        value: settingValue(state, 'autoAlertVolume'),
        min: 30,
        max: 100,
        step: 5
      }
    }
  },

  mounted () {
    const vm = this

    vm.getDevices()
    vm.stopDeviceWatch = onAudioDevicesChange(vm.getDevices)
  },

  beforeDestroy () {
    this.stopDeviceWatch?.()
  },

  computed: {
    ...mapGetters({
      flag: 'agentModule/flag'
    }),

    ...mapState({
      sipConnected: ({ sipModule }) => sipModule.sipConnected,

      state: ({ settingsModule, agentModule }) => {
        const agentStatus = agentModule?.session?.agent?.status
        const isLogged = Boolean(agentStatus && agentStatus !== 'OFFLINE')
        return Object.assign({}, settingsModule, { isLogged })
      }
    }),

    binaryVersion () {
      return window.app?.version()
    },

    formValues () {
      return SETTINGS_NAMES.reduce((values, name) => {
        values[name] = this.fieldValue(name)
        return values
      }, {})
    },

    visibleFields () {
      return visibleFieldNames({ flag: this.flag, values: this.formValues })
    },

    disableSave () {
      const vm = this
      const values = vm.formValues
      const isEmpty = (value) => [undefined, null, ''].includes(value)

      if (vm.visibleFields.some((name) => isEmpty(values[name]))) return true
      return vm.visibleFields.includes('dndOptionsList') && !values.dndOptionsList.length
    }
  },

  methods: {
    ...mapActions({
      clearError: 'settingsModule/clearError',
      saveSettings: 'settingsModule/saveSettings',
      setAutoRejection: 'agentModule/setAutoRejection',
      playBeepAlert: 'sipModule/playBeepAlert'
    }),

    testAutoAlert () {
      this.playBeepAlert(this.autoAlertVolume.value)
    },

    isVisible (name) {
      return this.visibleFields.includes(name)
    },

    fieldValue (name) {
      const field = this[name]
      return field && typeof field === 'object' && !Array.isArray(field) ? field.value : field
    },

    onSaveSettings () {
      const vm = this
      vm.loading = true

      const values = vm.formValues

      const config = vm.visibleFields.reduce((payload, name) => {
        if (![undefined, null].includes(values[name])) payload[name] = values[name]
        return payload
      }, {})

      if (config.useDND !== 'yes') vm.setAutoRejection(false)

      vm.saveSettings(config)
    },

    onCancel () {
      this.$router.go(-1)
    },

    async getDevices () {
      const devices = await listAudioDevices()
      const state = this.$store.state.settingsModule
      this.inputPhone.list = devices.audioinput
      this.outputPhone.list = devices.audiooutput
      this.micDenied = devices.micDenied

      AUDIO_DEVICE_FIELDS.forEach(({ key, kind }) => {
        const isAvailable = (id) => devices[kind].some((device) => device.id === id)
        if (isAvailable(this[key].value)) return
        const saved = settingValue(state, key)
        this[key].value = isAvailable(saved) ? saved : null
      })

      this.devicesLoaded = true
    },

    deviceHint (key) {
      if (!this.devicesLoaded || this[key].value) return ''
      if (this.micDenied) return 'Acesso ao microfone bloqueado. Permita nas configurações do site.'
      const list = key === 'inputPhone' ? this.inputPhone.list : this.outputPhone.list
      if (!list.length) return 'Nenhum dispositivo encontrado. Conecte o headset.'
      return 'O dispositivo configurado não está conectado. Selecione outro.'
    }
  },

  watch: {
    state ({ loading }) {
      if (loading !== this.loading) this.loading = loading
    }
  }
}

</script>

<style lang="sass" scoped>
  @import '@/styles/quasar.variables.scss'

  .app-settings
    .uppercase
      text-transform: uppercase

    .center-text
      display: block
      width: fit-content
      margin: 0 auto

    .welcome
      font-weight: 700
      font-size: 28px
      color: #01253C

    .instructions
      font-weight: normal
      font-size: 16px
      color: #52707F

    .pad-panel
      padding: 25px 32px

    .mt8
      display: block
      margin-top: 8px

    .mt20
      display: block
      margin-top: 20px

    .panel
      width: 100%
      max-width: 508px
      margin: 16px auto 0

    .provision
      font-weight: 600
      font-size: 12px
      text-transform: uppercase
      letter-spacing: 0.05em
      color: #52707F

    .label
      display: block
      font-weight: 500
      font-size: 12px
      color: #52707F
      padding-bottom: 2px

    .device-hint
      display: flex
      align-items: center
      gap: 4px
      margin-top: 4px
      font-size: 12px
      color: $negative

    .copy
      cursor: pointer
      font-size: 10px
      float: right
      color: $primary

    .appVersion
      font-weight: normal
      font-size: 12px
      line-height: 14px
      color: #757575

    .q-field__control
      height: 36px
      min-height: 36px
      padding: 0 4px 0 8px
      border-radius: 6px

      .q-field__control-container
        font-style: normal
        font-weight: normal
        font-size: 13px
        line-height: 18px
        color: rgba(1, 37, 60, 0.9)

      &:before
        border-color: #CDDCE5

      &:hover
        &:before
          border: 1px solid #1769B6
          transition: none

      &:after
        border-width: 1px !important

    .q-field__control-container
      .q-field__native
        min-height: 0px !important
        padding-bottom: 5px

      .q-field__prefix
        line-height: inherit !important
        margin-bottom: 1px
        padding: 1px 1px 0 0

    .q-field__marginal
      height: 36px
      padding-bottom: 0px
</style>
